import type { AdsPageLineItem } from '../../../../common/AdForm/types';
import type { Asset2Extended } from '../../../../models';
import { getCountryCodesFromAsset } from './getCountryCodesFromAsset';
import { getCountryCodesFromLineItem } from './getCountryCodesFromLineItem';

export type AssetCountryCodesInput = {
  countryCodes: string[];
};

export function buildAssetCountryCodesInput(
  lineItem?: AdsPageLineItem,
  assets?: Asset2Extended[]
): AssetCountryCodesInput | undefined {
  if (!assets?.length) return;

  const countriesFromAsset = getCountryCodesFromAsset(assets[0]);
  const countriesFromLineItem = getCountryCodesFromLineItem(lineItem);
  const countryCodes = [...new Set([...countriesFromAsset, ...countriesFromLineItem])];

  return {
    countryCodes,
  };
}
